export default {
  ULTRA_WIDE: 'ultraWideImage',
  DESKTOP: 'desktopImage',
  SMALL_DESKTOP: 'smallDesktopImage',
  TABLET: 'tabletImage',
  LARGE_MOBILE: 'largeMobileImage',
  SMALL_MOBILE: 'smallMobileImage',
};
